<template>
  <div>
    <a
      class="cursor-pointer text-primary-90 text-primary-100:hover"
      @click="importFile()"
    ><i class="fas fa-upload"></i> Import spreadsheet</a>
  </div>
</template>

<script>
import util from '@/util'
import gaCategories from '@/constant/gaCategories'

export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    importFile() {
      this.$store.state.openModalImportSheet = true
      util.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Import Sheet File > Click Import',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
